import { render, staticRenderFns } from "./StepLink.vue?vue&type=template&id=10e01a56&scoped=true"
import script from "./StepLink.vue?vue&type=script&lang=js"
export * from "./StepLink.vue?vue&type=script&lang=js"
import style0 from "./StepLink.vue?vue&type=style&index=0&id=10e01a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e01a56",
  null
  
)

export default component.exports